import { PropsWithChildren, ReactNode } from "react";
import {
  cn,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  V2Dialog,
} from "web-design-system";
import { ScaledFrame } from "./scaled-frame";

type PreviewDialogProps = PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  /** Size the preview is laid out at before it is scaled to fit */
  width: number;
  height: number;
  footer?: ReactNode;
  /** Overrides the dialog size */
  className?: string;
}>;

/** Shows one of the branding previews enlarged */
export function PreviewDialog({
  open,
  onOpenChange,
  title,
  description,
  width,
  height,
  footer,
  className,
  children,
}: PreviewDialogProps) {
  return (
    <V2Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "flex h-[min(calc(100dvh-2rem),720px)] w-[min(calc(100vw-2rem),840px)] max-w-none flex-col gap-0 overflow-hidden p-0 sm:rounded-2xl",
          className
        )}
      >
        <DialogHeader className="space-y-2 border-b border-border px-6 py-5">
          <DialogTitle className="text-lg!">{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="flex-1 min-h-0 p-6">
          <div className="size-full rounded-2xl bg-secondary p-8">
            <ScaledFrame width={width} height={height}>
              {children}
            </ScaledFrame>
          </div>
        </div>

        {footer && (
          <DialogFooter className="border-t border-border px-6 py-4">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </V2Dialog>
  );
}
